import React from 'react';

const Container = ({ children, as = 'div' }) => {
  const Tag = as;

  return (
    <Tag
      style={{
        padding: 'var(--space-lg) var(--size-gutter)',
        border: '1px solid var(--border)',
        background: 'var(--background-header)',
        boxShadow: '0px 4px 4px var(--shadow)',
        position: 'sticky',
        zIndex: 99,
        width: '100%',
        top: 0,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </Tag>
  );
};

export default Container;
